import useAthleteUserPayments from './UseAthleteUserPayments';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import ShoppingCart from '@usas/ui-web/components/payments/ShoppingCart';

const AthleteUserPayments = () => {
  const {
    redirectToPurchases,
    redirectToEntries,
    orgUnitAthleteEntryId
  } = useAthleteUserPayments();

  return (
    <ViewTemplate
      viewName={Views.OME_MEET_SUBMIT}>
      <ShoppingCart isBarOnBottom={false} itemSubsystemId={3} itemContract={11} referenceId={orgUnitAthleteEntryId} onPaymentCompletion={redirectToEntries} onPaymentCancel={redirectToPurchases}></ShoppingCart>
    </ViewTemplate>
  );
};

export default AthleteUserPayments;
